import { render, staticRenderFns } from "./CarBonanza.vue?vue&type=template&id=24a314ee&"
import script from "./CarBonanza.vue?vue&type=script&lang=js&"
export * from "./CarBonanza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports